module.exports = __webpack_public_path__ + "img/assets-bg.60745ead.png";